<template>
  <div>
    <v-card :elevation="1" class="v-sheet theme--light br-0">
      <v-card-title>
        <v-row class="col-md-12">
          <v-col cols="12" sm="12" md="6"> Expedientes Fisicos </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-btn
              color=""
              dark
              class="mb-2 float-right blue-grey darken-2"
              :to="{ name: 'ingresoFisico' }"
            >
              Registrar Expediente
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="col-md-12 m-0 p-0">
          <v-divider></v-divider>
        </v-row>
      </v-card-title>
      <v-card-text class="pl-0 pr-0">
        <v-data-table
          class="elevation-0"
          :headers="headers"
          :items="items"
          :search="filtro"
          :loading="tableLoading"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-page-first',
            lastIcon: 'mdi-page-last',
            prevIcon: 'mdi-chevron-left',
            nextIcon: 'mdi-chevron-right',
            'items-per-page-text': 'Registros por página',
            pageText: '{0}-{1} de {2}',
          }"
        >
          <template v-slot:top>
            <!-- v-container, v-col and v-row are just for decoration purposes. -->
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                  <v-text-field
                    autocomplete="off"
                    class="required"
                    dense
                    filled
                    color="blue-grey lighten-2"
                    v-model="filtro"
                    label="Número, nombre del proyecto, descripción..."
                    maxlength="200"
                  >
                    <v-icon slot="append" color="black"> mdi-magnify </v-icon>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                  <v-select
                    v-model="estadoProyecto"
                    :items="estadosProyecto"
                    :loading="false"
                    dense
                    filled
                    label="Estado"
                    :no-data-text="'No existen estados registrados'"
                    menu-props="auto"
                    return-object
                  ></v-select>
                </v-col>

                <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                  <v-btn
                    class="ma-0 white--text d-none"
                    medium
                    color="light-blue darken-2"
                  >
                    <v-icon left>mdi-magnify</v-icon> Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <!--<td class="text-right">
                <v-tooltip
                  right
                  color="white"
                  v-if="
                    item.requisitosCargados < item.requisitosRequeridos ||
                    item.tdrCargados < item.tdrRequeridos ||
                    (item.edictosCargados === 0 &&
                      item.tiposInstrumentoId === 1) ||
                    (item.equipoTrabajo === 0 &&
                      (item.tiposInstrumentoId === 4 ||
                        item.tiposInstrumentoId === 1))
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="warning" dark v-bind="attrs" v-on="on">
                      fas fa-info-circle icon-md
                    </v-icon>
                  </template>
                  <p v-if="item.requisitosCargados < item.requisitosRequeridos">
                    <span class="black--text"
                      >Tiene REQUISITOS requeridos sin cargar.</span
                    >
                  </p>
                  <p v-if="item.tdrCargados < item.tdrRequeridos">
                    <span class="black--text"
                      >Tiene TDR requeridos sin cargar.</span
                    >
                  </p>
                  <p
                    v-if="
                      item.edictosCargados === 0 &&
                      item.tiposInstrumentoId === 1
                    "
                  >
                    <span class="black--text"
                      >El expediente no cuenta con EDICTOS.</span
                    >
                  </p>
                  <p
                    v-if="
                      item.consultor === 0
                      //&&
                      //(item.tiposInstrumentoId === 4 ||
                      //item.tiposInstrumentoId === 1)
                    "
                  >
                    <span class="black--text"
                      >El expediente necesita consultor titular.</span
                    >
                  </p>
                </v-tooltip>
                {{ item.id }}
              </td>-->
              <td class="text-center">
                <v-tooltip
                  right
                  color="white"
                  v-if="item.tiposInstrumentoId === 1"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="warning" dark v-bind="attrs" v-on="on">
                      fas fa-info-circle icon-md
                    </v-icon>
                  </template> </v-tooltip
                >{{ item.noexpediente }}
              </td>
              <td class="text-center">{{ item.nombreProyecto }}</td>
              <td class="text-center">
                {{ item.categoria }}
              </td>
              <td class="text-center">
                {{ item.siglas }}
              </td>
              <td class="text-center">
                <v-chip
                  class="ma-2 font-weight-medium"
                  label
                  :color="
                    item.estadoid === 1
                      ? 'blue lighten-4'
                      : item.estadoid === 2
                      ? 'cyan lighten-4'
                      : item.estadoid === 5
                      ? 'green lighten-2'
                      : item.estadoid === 6
                      ? 'cyan lighten-4'
                      : item.estadoid === 7
                      ? 'deep-orange lighten-4'
                      : item.estadoid === 17
                      ? 'teal lighten-3'
                      : 'pink lighten-4'
                  "
                  :text-color="
                    item.estadoid === 1
                      ? 'blue lighten-1'
                      : item.estadoid === 2
                      ? 'cyan darken-1'
                      : item.estadoid === 5
                      ? 'green darken-1'
                      : item.estadoid === 6
                      ? 'green--text'
                      : item.estadoid === 7
                      ? 'deep-orange lighten-1'
                      : item.estadoid === 17
                      ? 'green darken-1'
                      : 'pink darken-1'
                  "
                  small
                >
                  {{ item.estado }}
                </v-chip>
              </td>
              <td class="text-center">
                <!--v-btn
                  v-if="item.estadosId === 1"
                  class="
                    ma-2
                    btn-bg-light
                    blue-grey--text
                    lighten-2--text
                    font-weight-medium
                    text-capitalize
                  "
                  small
                  depressed
                  color="blue-grey lighten-5"
                  @click="obtenerDatosItem(item.id, 1)"
                >
                  <v-icon left>mdi-pencil</v-icon> Actualizar
                </!--v-btn-->
                <v-btn
                  v-if="item.estadoid === 1"
                  class="green--text m-4"
                  dark
                  color="teal lighten-5"
                  small
                  depressed
                  @click="modalPagar(item)"
                >
                  <v-icon left>mdi-send</v-icon> Generar Boleta de Cobro
                </v-btn>

                <!--                <v-btn-->
                <!--                  v-if="-->
                <!--                    (item.estadosExpedienteId === 1 &&-->
                <!--                      item.edictosCargados !== 0 &&-->
                <!--                      item.tiposInstrumentoId === 1 &&-->
                <!--                      item.consultor !== 0 &&-->
                <!--                      item.tipo_Inversion !== 'Pública' &&-->
                <!--                      isButtonVisible) ||-->
                <!--                    (item.estadosExpedienteId === 1 &&-->
                <!--                      item.consultor !== 0 &&-->
                <!--                      item.tiposInstrumentoId !== 1 &&-->
                <!--                      item.tipo_Inversion !== 'Pública' &&-->
                <!--                      isButtonVisible)-->
                <!--                  "-->
                <!--                  class="green&#45;&#45;text m-4"-->
                <!--                  dark-->
                <!--                  color="teal lighten-5"-->
                <!--                  small-->
                <!--                  depressed-->
                <!--                  @click="modalPagar(item.id)"-->
                <!--                >-->
                <!--                  <v-icon left>mdi-cash</v-icon> Pagar ingreso-->
                <!--                </v-btn>-->

                <!--                <v-btn-->
                <!--                  v-if="-->
                <!--                    (item.estadosExpedienteId === 1 &&-->
                <!--                      item.requisitosCargados === item.requisitosRequeridos &&-->
                <!--                      item.tdrCargados === item.tdrRequeridos &&-->
                <!--                      item.edictosCargados !== 0 &&-->
                <!--                      item.tiposInstrumentoId === 1 &&-->
                <!--                      item.consultor !== 0 &&-->
                <!--                      item.tipo_Inversion === 'Pública') ||-->
                <!--                    (item.estadosExpedienteId === 1 &&-->
                <!--                      item.requisitosCargados === item.requisitosRequeridos &&-->
                <!--                      item.tdrCargados === item.tdrRequeridos &&-->
                <!--                      item.consultor !== 0 &&-->
                <!--                      item.tiposInstrumentoId !== 1 &&-->
                <!--                      item.tipo_Inversion === 'Pública')-->
                <!--                  "-->
                <!--                  class="blue-grey&#45;&#45;text m-4"-->
                <!--                  dark-->
                <!--                  color="teal lighten-5"-->
                <!--                  small-->
                <!--                  depressed-->
                <!--                  @click="enviarExpedientePreanalisis(item.id)"-->
                <!--                >-->
                <!--                  <v-icon left>mdi-send</v-icon> Enviar Expediente-->
                <!--                </v-btn>-->

                <!--                <v-btn-->
                <!--                  v-if="item.estadosExpedienteId === 8"-->
                <!--                  class="green&#45;&#45;text m-4"-->
                <!--                  dark-->
                <!--                  color="teal lighten-5"-->
                <!--                  small-->
                <!--                  depressed-->
                <!--                  @click="enviarExpedientePreanalisis(item.id)"-->
                <!--                >-->
                <!--                  <v-icon left>mdi-send</v-icon> Enviar pre analisis-->
                <!--                </v-btn>-->
                <v-btn
                  v-if="
                    item.estadosExpedienteId === 1 ||
                    (item.estadosExpedienteId === 4 &&
                      item.anotacionesCount !== item.anotacionesEnviadas) ||
                    item.estadosExpedienteId === 11
                  "
                  class="blue--text m-4"
                  dark
                  color="blue lighten-5"
                  small
                  depressed
                  :to="{
                    name: 'actualizar-expediente',
                    params: { id: item.id, estado: item.estadosExpedienteId },
                  }"
                >
                  <v-icon left>fas fa-edit</v-icon> Editar
                </v-btn>
                <!--                <v-btn-->
                <!--                  v-if="item.estadosExpedienteId === 5"-->
                <!--                  class="black&#45;&#45;text m-4"-->
                <!--                  darkS-->
                <!--                  color="blue-grey lighten-5"-->
                <!--                  small-->
                <!--                  depressed-->
                <!--                  @click="modalPagar(item.id, item.exonerado)"-->
                <!--                >-->
                <!--                  <v-icon left>fas fa-money-check</v-icon> Pagar-->
                <!--                </v-btn>-->
                <v-btn
                  v-if="item.estadosExpedienteId === 6"
                  class="black--text m-4"
                  darkS
                  color="blue-grey lighten-5"
                  small
                  depressed
                  @click="reinprimir(item.id)"
                >
                  <v-icon left>fas fa-print</v-icon> Reimprimir Cobro
                </v-btn>
                <v-btn
                  v-if="
                    item.pathResolucion &&
                    (item.estadosExpedienteId === 17 ||
                      item.estadosExpedienteId === 21)
                  "
                  class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                  small
                  depressed
                  color="blue-grey lighten-5"
                  @click="
                    descargarArchivoBackend(item.pathResolucion, 1, item.id)
                  "
                >
                  <v-icon left>mdi-file-download-outline</v-icon>
                  Descargar Resolución
                </v-btn>
                <v-btn
                  v-if="item.path_Rechazo && item.estadosExpedienteId === 9"
                  class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                  small
                  depressed
                  color="blue-grey lighten-5"
                  @click="descargarArchivo(item.path_Rechazo)"
                >
                  <v-icon left>mdi-file-download-outline</v-icon>
                  Descargar Resolución de Rechazo
                </v-btn>
                <!--                <v-btn-->
                <!--                  v-if="-->
                <!--                    item.estadosExpedienteId !== 9 &&-->
                <!--                    item.estadosExpedienteId !== 1 &&-->
                <!--                    item.estadosExpedienteId !== 2 &&-->
                <!--                    item.estadosExpedienteId !== 3 &&-->
                <!--                    item.estadosExpedienteId !== 4 &&-->
                <!--                    item.estadosExpedienteId !== 5 &&-->
                <!--                    item.estadosExpedienteId !== 6 &&-->
                <!--                    item.estadosExpedienteId !== 28-->
                <!--                  "-->
                <!--                  class="ma-2 btn-bg-light blue-grey&#45;&#45;text lighten-2&#45;&#45;text font-weight-medium text-capitalize"-->
                <!--                  small-->
                <!--                  depressed-->
                <!--                  color="blue-grey lighten-5"-->
                <!--                  @click="descargarConstanciaIngreso(item.id)"-->
                <!--                >-->
                <!--                  <v-icon left>mdi-file-download-outline</v-icon>-->
                <!--                  Descargar Formulario de Ingreso-->
                <!--                </v-btn>-->
                <!--                <v-btn-->
                <!--                  v-if="-->
                <!--                    item.estadosExpedienteId !== 9 &&-->
                <!--                    item.estadosExpedienteId !== 1 &&-->
                <!--                    item.estadosExpedienteId !== 2 &&-->
                <!--                    item.estadosExpedienteId !== 3 &&-->
                <!--                    item.estadosExpedienteId !== 4 &&-->
                <!--                    item.estadosExpedienteId !== 5 &&-->
                <!--                    item.estadosExpedienteId !== 6 &&-->
                <!--                    item.estadosExpedienteId !== 28-->
                <!--                  "-->
                <!--                  class="ma-2 btn-bg-light blue-grey&#45;&#45;text lighten-2&#45;&#45;text font-weight-medium text-capitalize"-->
                <!--                  small-->
                <!--                  depressed-->
                <!--                  color="blue-grey lighten-5"-->
                <!--                  @click="cargarConstanciaIngreso(item.id)"-->
                <!--                >-->
                <!--                  <v-icon left>mdi-file-download-outline</v-icon>-->
                <!--                  Descargar Constancia de Ingreso-->
                <!--                </v-btn>-->
                <!--v-btn
                  class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                  small
                  depressed
                  color="blue-grey lighten-5"
                  @click="modalRepoDocs()"
                >
                  <v-icon left>fas fa-file-download</v-icon>
                  Repositorio de Documentos
                </!--v-btn-->
                <v-btn
                  v-if="item.pathLicenciaVigente"
                  class="blue--text m-4"
                  dark
                  color="blue lighten-5"
                  small
                  depressed
                  @click="
                    descargarArchivoBackend(
                      item.pathLicenciaVigente,
                      1,
                      item.id
                    )
                  "
                >
                  <v-icon left>mdi-file-download-outline</v-icon>
                  Descargar Licencia Ambiental
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <!-- <template v-slot:html>
            {{ code4.html }}
          </template>
          <template v-slot:js>
            {{ code4.js }}
          </template> -->
    </v-card>
    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogEnvio"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Envío de expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioLoading"
            @click="dialogEnvio = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>{{ mesajePresentarExpediente }}</h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogEnvio = false"
            :disabled="btnEnvioLoading"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente"
            :loading="btnEnvioLoading"
          >
            Sí, enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--begin:: modal registro-->
    <v-dialog
      v-model="dialogEdicto"
      max-width="600"
      transition="scroll-y-transition"
      persistent
      scrollable
    >
      <v-card tile>
        <v-card-title>
          Enviar Expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnRegistroEdictoLoading"
            @click="
              dialogEdicto = false;
              resetDatosEdicto();
            "
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="d-none"></v-divider>
        <v-alert
          outlined
          :type="edicto ? 'indigo' : 'red'"
          prominent
          border="left"
          class="m-3"
        >
          {{ mensajeEdicto }}
        </v-alert>
        <v-card-text v-if="edicto" class="pl-8 pr-8 pt-5">
          <v-form
            ref="form"
            v-on:submit.prevent="(dialogEnvio = true), (dialogEdicto = false)"
            v-model="validEdictoForm"
          >
            <v-row>
              <v-col cols="12" md="12" class="pt-4 pb-0">
                <v-autocomplete
                  :readonly="true"
                  :loading="mediosLoading"
                  v-model="datosEdictoItem.medioComunicacionId"
                  :items="itemsMedios"
                  class="required"
                  dense
                  filled
                  label="Medio de Comunicación"
                  item-text="nombre"
                  item-value="id"
                  :rules="[selectRequired('Medio de Comunicación')]"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" class="pt-4 pb-0">
                <v-text-field
                  :readonly="true"
                  autocomplete="off"
                  class=""
                  dense
                  filled
                  color="blue-grey darken-2"
                  v-model="fechas.fechaIniciaVP"
                  label="Fecha inicial de Vista Pública"
                  :rules="[]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" class="pt-4 pb-0">
                <v-text-field
                  :readonly="true"
                  autocomplete="off"
                  class=""
                  dense
                  filled
                  color="blue-grey darken-2"
                  v-model="fechas.fechaFinalizaVP"
                  label="Fecha de finalización de Vista Pública"
                  :rules="[]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" class="pt-4 pb-0">
                <v-text-field
                  :readonly="true"
                  autocomplete="off"
                  class=""
                  dense
                  filled
                  color="blue-grey darken-2"
                  v-model="fechas.fechaPublicacion"
                  label="Fecha Publicación"
                  :rules="[]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" class="pt-4 pb-0">
                <v-textarea
                  :readonly="true"
                  autocomplete="off"
                  class=""
                  dense
                  filled
                  color="blue-grey darken-2"
                  v-model="datosEdictoItem.observaciones"
                  label="Observaciones"
                  :rules="[]"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn
                  color="grey lighten-5"
                  elevation="0"
                  class="mb-2 float-right grey lighten-5"
                  @click="
                    dialogEdicto = false;
                    resetDatosEdicto();
                  "
                  :disabled="btnRegistroEdictoLoading"
                >
                  Cancelar
                </v-btn>
                <!--:disabled="!validDocForm" type="submit"-->
                <v-btn
                  color="primary"
                  class="mb-2 float-right"
                  type="submit"
                  :elevation="0"
                  :disabled="!validEdictoForm"
                  :loading="btnRegistroEdictoLoading"
                >
                  Aceptar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogPago"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Pagar Expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioLoading"
            @click="dialogPago = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row cols="6">
            <v-col
              cols="6"
              md="6"
              class="pt-4 pb-0"
              v-if="mostrarPagoVisa === false"
            >
              <v-card class="mx-auto" max-width="344" outlined elevation="4">
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="text-overline mb-4">Generar Cobro</div>
                    <v-list-item-title class="text-h5 mb-1">
                      Banrural
                    </v-list-item-title>
                    <!--v-list-item-subtitle>Q100.00</!--v-list-item-subtitle-->
                  </v-list-item-content>
                  <span>
                    <v-icon slot="append" color="green">
                      fas fa-money-bill icon-4x
                    </v-icon>
                  </span>
                </v-list-item>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    block
                    elevation="2"
                    class="green--text float-center"
                    dark
                    color="teal lighten-5"
                    @click="registrarCobroItem(1)"
                    :loading="btnRegistroCobroLoading"
                  >
                    Generar Cobro
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="6"
              class="pt-4 pb-0"
              v-if="mostrarPagoVisa === true"
            >
              <v-card class="mx-auto" max-width="344" outlined elevation="4">
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="text-overline mb-4">Generar Cobro</div>
                    <v-list-item-title class="text-h5 mb-1">
                      Banrural
                    </v-list-item-title>
                    <!--v-list-item-subtitle>Q100.00</!--v-list-item-subtitle-->
                  </v-list-item-content>
                  <span>
                    <v-icon slot="append" color="green">
                      fas fa-money-bill icon-4x
                    </v-icon>
                  </span>
                </v-list-item>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    block
                    elevation="2"
                    class="green--text float-center"
                    dark
                    color="teal lighten-5"
                    @click="registrarCobroItem(1)"
                    :loading="btnRegistroCobroLoading"
                  >
                    Generar Cobro
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <!--            <v-col-->
            <!--              cols="12"-->
            <!--              md="6"-->
            <!--              class="pt-4 pb-0"-->
            <!--              v-if="mostrarPagoVisa === true"-->
            <!--            >-->
            <!--              <v-card class="mx-auto" max-width="344" outlined elevation="4">-->
            <!--                <v-list-item three-line>-->
            <!--                  <v-list-item-content>-->
            <!--                    <div class="text-overline mb-4">Pago con Tarjeta</div>-->
            <!--                    <v-list-item-title class="text-h5 mb-1">-->
            <!--                      VISA-->
            <!--                    </v-list-item-title>-->
            <!--                    &lt;!&ndash;v-list-item-subtitle>Q100.00</!&#45;&#45;v-list-item-subtitle&ndash;&gt;-->
            <!--                  </v-list-item-content>-->
            <!--                  <span>-->
            <!--                    <v-icon slot="append" color="black">-->
            <!--                      fas fa-money-check icon-4x-->
            <!--                    </v-icon>-->
            <!--                  </span>-->
            <!--                </v-list-item>-->

            <!--                <v-card-actions>-->
            <!--                  <v-spacer></v-spacer>-->
            <!--                  <v-btn-->
            <!--                    block-->
            <!--                    elevation="2"-->
            <!--                    class="black&#45;&#45;text float-center"-->
            <!--                    dark-->
            <!--                    color="blue-grey lighten-4"-->
            <!--                    @click="registrarCobroItem(2)"-->
            <!--                    :loading="btnRegistroCobroVisaLoading"-->
            <!--                  >-->
            <!--                    Pagar-->
            <!--                  </v-btn>-->
            <!--                </v-card-actions>-->
            <!--              </v-card>-->
            <!--            </v-col>-->
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--begin:: modal registro-->

    <!--begin:: dialog carga de documento -->
    <v-dialog
      v-model="dialogResolucionesOpinionesTecnicas"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Resoluciones Opinión Técnica

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnAgregarOpinion"
            @click="dialogResolucionesOpinionesTecnicas = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form1"
            v-on:submit.prevent="cargarArchivoOP"
            v-model="validFormOpinion"
          >
            <v-row class="mt-1 mb-10 ml-0 mr-0">
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col md="12" sm="12" class="pt-0 pb-0">
                <v-data-table
                  class="elevation-0"
                  :headers="headersResolucionesOT"
                  :loading="tableOPLoading"
                  :items="opinionesTecnicas"
                  :search="filtroOP"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-chevron-left',
                    nextIcon: 'mdi-chevron-right',
                    'items-per-page-text': 'Registros por página',
                    pageText: '{0}-{1} de {2}',
                  }"
                >
                  <template v-slot:top>
                    <!-- v-container, v-col and v-row are just for decoration purposes. -->
                    <v-row>
                      <v-col cols="12" md="12" sm="12" xs="12">
                        <v-text-field
                          autocomplete="off"
                          append-icon="mdi-magnify"
                          dense
                          filled
                          color="blue-grey darken-2"
                          v-model="filtroOP"
                          label="Buscar Opinión Técnica"
                          maxlength="100"
                        ></v-text-field>
                      </v-col>

                      <!--v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                        <v-btn
                          class="ma-0 white--text d-none"
                          medium
                          color="light-blue darken-2"
                        >
                          <v-icon left>mdi-magnify</v-icon> Buscar
                        </v-btn>
                      </!--v-col-->
                    </v-row>
                  </template>

                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.fechaEnvio }}</td>
                      <td>
                        <v-btn
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarArchivo(item.path)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar
                        </v-btn>
                      </td>
                      <td>
                        <v-chip
                          class="ma-2 font-weight-medium"
                          label
                          :color="
                            item.obligatorio === 1
                              ? 'teal'
                              : item.obligatorio === 0
                              ? 'pink'
                              : 'pink'
                          "
                          :text-color="
                            item.obligatorio === 1
                              ? 'white'
                              : item.obligatorio === 0
                              ? 'white'
                              : 'pink darken-1'
                          "
                          small
                        >
                          {{
                            item.obligatorio === 1
                              ? "Finalizada"
                              : "No Finalizada"
                          }}
                        </v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--fin:: dialog carga de documento -->

    <v-dialog
      v-model="dialogoBoleta"
      max-width="1200"
      transition="scroll-y-transition"
      persistent
      scrollable
    >
      <v-card tile>
        <v-card-title>
          Boleta de Pago

          <v-spacer></v-spacer>
          <v-btn icon @click="dialogoBoleta = false" class="float-right">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="d-none"></v-divider>

        <v-card-text class="pl-8 pr-8 pt-5">
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <iframe
                :src="documento"
                width="100%"
                height="600px"
                frameborder="0"
              ></iframe>
            </v-col>
          </v-row>
          <!--/-v-form-->
        </v-card-text>

        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>

    <!--end:: modal registro-->
    <DialogLoader
      :dialogVisible="dialogLoaderVisible"
      :text="dialogLoaderText"
      transition="scroll-y-transition"
    ></DialogLoader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    <template>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          :filename="`Cobromarn`"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2PdfCobro"
        >
          <!--@progress="onProgress($event)"-->
          <section slot="pdf-content" class="pdf-content">
            <!-- PDF Content Here -->
            <PdfCobro
              :datosPdf="datosPdf"
              :tipoPago="tipoPago"
              v-if="montarPdf === true"
            />
          </section>
        </vue-html2pdf>
      </div>
    </template>

    <!-- PDF Content Here -->

    <template>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          :filename="`Constancia_Ingreso_Expediente`"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
        >
          <!--@progress="onProgress($event)"-->
          <section slot="pdf-content" class="pdf-content">
            <!-- PDF Content Here -->
            <IngresoExpedientePdf
              :datosExpedientePdf="datosExpedientePdf"
              v-if="montarConstanciaPdf === true"
            />
          </section>
        </vue-html2pdf>
      </div>
    </template>
    <!-- Fin:: Snack alert-->
  </div>
  <!--fin:: visualizacion de la negociacion-->
</template>
<!--inicio:: visualizacion de la negociacion -->
<script>
import moment from "moment";
import Vue from "vue";
import JwtService from "@/core/services/jwt.service";

moment.locale("es");
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DialogLoader from "@/view/content/DialogLoader";
import SnackAlert from "@/view/content/alerts/SnackAlert.vue";
import PdfCobro from "@/view/components/cobro/Pdf.vue";
import validations from "@/core/untils/validations.js";
import VueHtml2pdf from "vue-html2pdf";

import {
  //OBTENER_EXPEDIENTES,
  ACTUALIZAR_ESTADO_EXPEDIENTE,
  VALIDAR_PRESENTACION_EXPEDIENTE,
  OBTENER_EXPEDIENTES_FISICOS,
} from "@/core/services/store/expedientes/expedientes.module";
import { OBTENER_MEDIOS } from "@/core/services/store/medioscomunicacion/medioscomunicacion.module";
import {
  REGISTRAR_COBRO_BANRURAL_BI,
  REGISTRAR_DETALLE_COBRO_BANRURAL_BI,
  REQUEST_COBRO_FISICO,
} from "@/core/services/store/cobros/cobros.module";
import { DESCARGAR_PLANTILLA_INGRESO } from "@/core/services/store/plantillasIngreso/plantillasingresoexpediente.module";
import {
  REGISTRAR_EDICTO,
  OBTENER_EDICTOS_BY_EXPEDIENTE,
} from "@/core/services/store/edictos/edictos.module";
import IngresoExpedientePdf from "@/view/components/reportes/IngresoExpedientePdf.vue";
import { OBTENER_EXPEDIENTE_VP } from "@/core/services/store/expedientes/expedientes.module";
/*
import {OBTENER_CONTACTOS, REGISTRAR_CONTACTO} from "@/core/services/store/contactos/contacto.module";
*/

export default {
  name: "AdminExpedientes",
  data() {
    return {
      currentHour: new Date().getHours(),
      tipoPago: "BANRURAL",
      tab: null,
      tabContactosDisabled: true,
      tableLoading: false,
      validForm: false,
      dialogEnvio: false,
      montarConstanciaPdf: false,
      btnEnvioLoading: false,
      btnRegistroContactoLoading: false,
      contactos: [],
      tableContactosLoading: false,
      ddRolesLoading: false,
      dialogRegistro: false,
      dialogLoaderVisible: false,
      dialogLoaderText: "Cargando...",
      switchItemEstado: true,
      proyectoSeleccionado: "",
      filtro: "",
      tiposContacto: [
        { id: 1, tipo: "De la institución" },
        { id: 2, tipo: "Trabajador" },
      ],
      tipoContactoSeleccionado: {},
      dialog: false,
      dialogTitle: "Registrar nuevo proyecto",
      accion: 1,
      btnRegistroText: "Guardar",
      btnRegistroLoading: false,
      estadoProyecto: "",
      tiposInstitucion: [],
      items: [],
      cargos: [],
      datosEnvioItem: {
        id: 0,
        estadoExpedienteId: 2, //presentado
        usuario: "admin",
      },
      fechas: {
        fechaIniciaVP: "",
        fechaFinalizaVP: "",
        fechaPublicacion: "",
      },
      estadosProyecto: [
        { text: "Todos", value: null },
        { value: 1, text: "Registro" },
        { value: 2, text: "Presentado" },
        { value: 3, text: "Prevalidacion" },
        { value: 4, text: "Anotación" },
        { value: 5, text: "Pago" },
        { value: 6, text: "En Pago" },
        { value: 7, text: "Pre-Análisis" },
        { value: 8, text: "Vista Pública" },
        { value: 9, text: "Espera Vista Pública" },
        { value: 10, text: "Análisis" },
        { value: 11, text: "Ampliación" },
        { value: 12, text: "Pre-Resolución" },
        { value: 13, text: "Resolución" },
        { value: 14, text: "Pre-Firma" },
        { value: 15, text: "Firma" },
        { value: 16, text: "Corrección Asesor" },
        { value: 17, text: "Aprobado" },
        { value: 18, text: "Asignación Asesores" },
        { value: 19, text: "OpinionTecnica" },
        { value: 20, text: "Ampliación Rechazada" },
        { value: 21, text: "Cerrado" },
        { value: 22, text: "Solicitud Licencia" },
        { value: 23, text: "Pago Licencia" },
        { value: 24, text: "Firma Licencia" },
        { value: 25, text: "Notificar Licencia" },
        { value: 26, text: "Corrección Procurador" },
        { value: 27, text: "Solicitud Enmienda" },
      ],
      datosEdictoItem: {
        id: 0,
        iniciaVP: "2022-07-14",
        finalizaVP: "2022-07-14",
        fechaPublicacion: "2022-07-14",
        observaciones: "",
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        expedienteId: 0,
        medioComunicacionId: 0,
      },
      ...validations,
      dialogEdicto: false,
      validEdictoForm: false,
      btnRegistroEdictoLoading: false,
      expediente: null,
      menuFechaInicialVistaPublica: false,
      menuFechaFinalizaVistaPublica: false,
      menuFechaPublicacion: false,
      activePickerIniciaVP: null,
      activePickerFinalizaVP: null,
      activePickerPublicacion: null,
      mediosLoading: false,
      edicto: false,
      mensajeEdicto: "",
      dialogPago: false,
      btnRegistroCobroLoading: false,
      datosCobro: {
        id: 0,
        numeroCobro: 1,
        idDetalle: 0,
        id_Detalle: 0,
        monto: 100.0,
        descripcion: "PAGO DE EXPEDIENTE",
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        expedienteId: 0,
      },
      datosPdf: {
        // cobro: 0,
        // monto: 0,
        // descripcion: "",
        // fechaEmision: "",
        // no_Expediente: "",
        // categoria: "",
        // nitProponente: "",
        // nombreProponente: "",
        // direccionProponente: "",
        // telefonoProponente: "",
      },
      datosExpedientePdf: {},
      edictos: [],
      dialogRepoDocs: false,
      repodocs: [
        { id: 1, nombre: "CARÁTULA DE PRESENTACIÓN " },
        { id: 2, nombre: "Carta de Presentación" },
        { id: 3, nombre: "Presentación de planos obligatorios" },
        { id: 4, nombre: "Documentación Legal la Empresa Consultora" },
        { id: 5, nombre: "Índice" },
        { id: 6, nombre: "Marco Jurídico" },
        { id: 7, nombre: "Descripción del Proyecto" },
        { id: 8, nombre: "Edictos" },
        { id: 9, nombre: "Anexos" },
        { id: 10, nombre: "Plano de Localización" },
        { id: 11, nombre: "Plano de distribución arquitectónica" },
      ],
      expedienteId: 0,
      montarPdf: false,
      mostrarPagoVisa: true,
      validacionPresentacion: {},
      mesajePresentarExpediente: "",
      documento: null,
      dialogoBoleta: false,
    };
  },
  components: {
    DialogLoader,
    SnackAlert,
    VueHtml2pdf,
    PdfCobro,
    IngresoExpedientePdf,
  },
  methods: {
    modalRepoDocs() {
      this.dialogRepoDocs = true;
    },
    modalPagar(expediente) {
      this.expediente = expediente;
      // let exonerado =
      if (this.expediente.tipoInversion !== "Privada") {
        this.mostrarPagoVisa = false;
      } else {
        this.mostrarPagoVisa = true;
      }
      this.dialogPago = true;
      this.expedienteId = this.expediente.idExpediente;

      this.categoriaId = this.expediente.categoriaId;
      this.datosCobro.expedienteId = this.expediente.idExpediente;
    },
    reinprimir(expedienteId) {
      this.datosCobro.expedienteId = expedienteId;
      this.expedienteId = expedienteId;
      this.registrarCobroItem(1);
    },
    resetDatosEdicto() {
      this.datosEdictoItem = {
        id: 0,
        iniciaVP: "2022-07-14",
        finalizaVP: "2022-07-14",
        fechaPublicacion: "2022-07-14",
        observaciones: "",
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        expedienteId: 0,
        medioComunicacionId: 0,
      };
    },
    maxDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear());
      return date.toISOString().substr(0, 10);
    },
    minDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 60);
      return date.toISOString().substr(0, 10);
    },
    filtroEstado(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.estadoProyecto.value) {
        return true;
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value === this.estadoProyecto.text;
    },
    //Mostrar el dialogo para la suspension
    async mostrarDialogEnvio(
      id,
      nombreProyecto,
      categoriasId,
      tiposInstrumentoId
    ) {
      this.dialogLoaderVisible = true;
      this.proyectoSeleccionado = nombreProyecto;
      this.datosEnvioItem.estadoExpedienteId = 2; //presentado
      //this.obtenerItemsMedios();
      this.datosEnvioItem.id = id;
      if (categoriasId === 1 || categoriasId == 2) {
        if (tiposInstrumentoId == 1) {
          await this.obtenerDatosEdicto(id).then(() => {
            this.validarFechaPresentacion(id).then(() => {
              if (this.edicto) {
                if (this.validacionPresentacion.status === 200) {
                  this.dialogEnvio = true;

                  this.mesajePresentarExpediente =
                    "¿Está seguro de enviar el siguiente expediente?";
                } else {
                  this.mesajePresentarExpediente =
                    this.validacionPresentacion.message;
                  this.dialogEnvio = true;
                  this.datosEnvioItem.estadoExpedienteId = 28; //extemporaneo
                }
              } else {
                this.mensajeEdicto =
                  "El expediente necesita edicto para ser enviado, debe ingresar al expediente y crearlo.";
                this.dialogEdicto = true;
              }
            });
          });
        } else {
          this.mesajePresentarExpediente =
            "¿Está seguro de enviar el siguiente expediente?";
          this.dialogEnvio = true;
        }
      } else {
        this.mesajePresentarExpediente =
          "¿Está seguro de enviar el siguiente expediente?";
        this.dialogEnvio = true;
      }
      this.dialogLoaderVisible = false;
    },
    //!Obtener datos del edicto de un expediente especifico
    async obtenerDatosEdicto(id) {
      this.dialogLoaderVisible = true;
      if (id !== 0) {
        await this.$store
          .dispatch(OBTENER_EDICTOS_BY_EXPEDIENTE, id)
          .then((res) => {
            if (res.status === 200) {
              this.edictos = this.$store.state.edictos.edictos;
              this.accion = 2;
              this.edicto = true;
            } else {
              this.$refs.snackalert.SnackbarShow(
                "warning",
                "Alerta",
                `El expediente no cuenta con edicto.`
              );
              this.accion = 1;
              this.edicto = false;
            }
            this.dialogLoaderVisible = false;
          })
          .catch(() => {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`
            );
            this.dialogLoaderVisible = false;
          });
      }
    },
    //!Validar fecha de presentacion del expediente
    async validarFechaPresentacion(id) {
      this.dialogLoaderVisible = true;
      await this.$store
        .dispatch(VALIDAR_PRESENTACION_EXPEDIENTE, id)
        .then((res) => {
          // if (res.status === 200) {
          this.validacionPresentacion = res;
          // } else {

          // }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`
          );
          this.dialogLoaderVisible = false;
        });
    },
    //Enviar el expediente
    async enviarExpediente() {
      this.dialogLoaderVisible = true;
      await this.$store
        .dispatch(ACTUALIZAR_ESTADO_EXPEDIENTE, this.datosEnvioItem)
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.expedienteRegistrado = 1;
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.obtenerItems();
            this.resetCambioEstado();
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogEnvio = false;
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },
    //Enviar el pre analisis
    async enviarExpedientePreanalisis(id) {
      this.dialogLoaderVisible = true;
      await this.$store
        .dispatch(ACTUALIZAR_ESTADO_EXPEDIENTE, {
          id: id,
          estadoExpedienteId: 2,
          usuario: "Proponente",
        })
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.expedienteRegistrado = 1;
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.obtenerItems();
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogEnvio = false;
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },

    /// Obtener los items
    async obtenerItems() {
      this.items = [];
      this.tableLoading = true;

      await this.$store
        .dispatch(OBTENER_EXPEDIENTES_FISICOS, JwtService.getUserId())
        .then((res) => {
          if (res.status === 200) {
            this.items = this.$store.state.expedientes.expedientes;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /// Obtener los items
    async obtenerItemsMedios() {
      this.itemsMedios = [];
      this.mediosLoading = true;
      await this.$store
        .dispatch(OBTENER_MEDIOS, 1)
        .then((res) => {
          if (res.status === 200) {
            this.itemsMedios = this.$store.state.medioscomunicacion.medios;
          }
          this.mediosLoading = false;
        })
        .catch(() => {
          this.mediosLoading = false;
        });
    },
    async registrarEdictoItem() {
      this.dialogLoaderVisible = true;
      this.btnRegistroEdictoLoading = true;
      await this.$store
        .dispatch(REGISTRAR_EDICTO, this.datosEdictoItem)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.dialogEdicto = false;
            this.enviarExpediente();
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
          this.btnRegistroEdictoLoading = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
          this.dialogLoaderVisible = false;
          this.btnRegistroEdictoLoading = false;
        });
    },
    async registrarCobroItem(tipoPago) {
      if (tipoPago === 1) {
        try {
          this.solicitudCobroBI();
          this.dialogPago = false;
          this.dialogoBoleta = true;
        } catch (error) {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            "Ocurrió un error en el proceso de cobro."
          );
        }
      } else {
        this.btnRegistroCobroVisaLoading = true;
      }
      // Si el tipo de pago es Visa (tipoPago === 2), redirige a la página de pago Visa.
      if (tipoPago === 2) {
        this.$router.push({
          name: "pago-visa-bi",
          params: { id: this.datosCobro.expedienteId },
        });
      }
    },
    async solicitudCobroBI() {
      await this.$store
        .dispatch(REQUEST_COBRO_FISICO, {
          expedienteId: this.expediente.id,
          tipo: 2,
          categoriaId: this.expediente.categoriaId,
        })
        .then((res) => {
          if (res.status === 200) {
            this.cobroId = this.$store.state.cobros.requestCobroF.id;
            this.expedienteCobro = this.$store.state.cobros.requestExpedienteF;
            this.costoAplicable =
              this.$store.state.cobros.requestCobroBI.costoAplicable;

            this.registrarCobroBanrural();
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },
    async registrarCobroBanrural() {
      await this.$store
        .dispatch(REGISTRAR_COBRO_BANRURAL_BI, {
          expedienteId: this.expediente.id,
          cobroId: this.cobroId,
          tipoPago: 1,
          nombre: this.expedienteCobro.nombreProponente,
          nit: this.expedienteCobro.nitProponente,
          noExpediente: this.expediente.no_Expediente,
          observacion: "Ingreso de Expediente de Bajo Impacto",
          monto: this.costoAplicable,
          usuarioIngreso: JwtService.getUser(),
          sistemaId: 1,
          estadoId: 1,
          tipoImpacto: "FI",
        })
        .then((res) => {
          if (res.status === 200) {
            this.registroCobro = this.$store.state.cobros.cobroBI.data;
            this.registrarDetalleCobro();
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },
    async registrarDetalleCobro() {
      await this.$store
        .dispatch(REGISTRAR_DETALLE_COBRO_BANRURAL_BI, {
          costoGestionId: this.cobroId,
          registroCobroGestionId: this.registroCobro,
          usuarioIngreso: JwtService.getUser(),
          expedienteId: this.expediente.id,
          tipoImpacto: "FI",
        })
        .then((res) => {
          if (res.status === 200) {
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
          this.btnRegistroEdictoLoading = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
          this.dialogLoaderVisible = false;
          this.btnRegistroEdictoLoading = false;
        });
    },
    descargarArchivoBackend(path, tipo, id) {
      let newPath = path.replace(/\\/g, "/");
      //server
      //window.open("http://preprod-wsayb.marn.gob.gt" + newPath, "_blank");
      window.open(this.$UrlWebService + newPath, "_blank");
      if (tipo === 1) {
        this.datosEnvioItem.id = id;
        this.datosEnvioItem.estadoExpedienteId = 21;
        this.enviarExpediente();
      }
    },
    async cargarConstanciaIngreso(Id) {
      this.dialogLoaderVisible = true;
      await this.$store
        .dispatch(OBTENER_EXPEDIENTE_VP, Id)
        .then((res) => {
          if (res.status === 200) {
            this.datosExpedientePdf = res.data;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
        })
        .then(() => {
          this.montarConstanciaPdf = true;
        })
        .then(() => {
          this.descargarConstanciaIngresoPdf();
        })
        .then(() => {
          this.montarConstanciaPdf = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );

          this.dialogLoaderVisible = false;
          this.btnRegistroCobroLoading = false;
          this.btnRegistroCobroVisaLoading = false;
          this.montarConstanciaPdf = false;
        });
    },
    async descargarConstanciaIngresoPdf() {
      await this.$refs.html2Pdf.generatePdf();
    },
    async descargarConstanciaIngreso(Id) {
      this.dialogLoaderVisible = true;
      await this.$store
        .dispatch(DESCARGAR_PLANTILLA_INGRESO, Id)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              "Constancia generada exitosamente."
            );
            this.descargarArchivoPlantilla(res.message);
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
          this.dialogLoaderVisible = false;
        });
    },
    //!Descargar el archivo de respaldo
    descargarArchivo(path) {
      let newPath = path.replace(/\\/g, "/");
      //console.log(newPath);
      //server
      //window.open("http://preprod-interface.marn.gob.gt" + newPath, "_blank");
      //local
      window.open("http://localhost:8080" + newPath, "_blank");
    },
    descargarArchivoPlantilla(path) {
      let newPath = path.replace(/\\/g, "/");
      //server
      //window.open("http://preprod-wsayb.marn.gob.gt" + newPath, "_blank");
      //local
      window.open("http://localhost:8080" + newPath, "_blank");
    },
    resetCambioEstado() {
      this.datosEnvioItem = {
        id: 0,
        estadoExpedienteId: 2,
        usuario: "admin",
      };
    },
  },
  created() {
    this.obtenerItems();
    //this.descargarConstanciaIngreso(11);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Inicio", route: "/dashboard" },
      { title: "Expedientes" },
    ]);
    // Puedes actualizar la hora cada minuto si es necesario
    setInterval(() => {
      this.currentHour = new Date().getHours();
    }, 60000);
  },

  computed: {
    // currentUser: {
    //   get() {
    //     return this.$store.state.auth.user;
    //   },
    // },
    isButtonVisible() {
      const currentHour = new Date().getHours();
      // Habilitar el botón entre las 8:00 AM (08) y las 4:00 PM (16)
      return currentHour >= 8 && currentHour < 16;
    },

    headers() {
      return [
        /*{
          text: "Track Id",
          align: "start",
          sortable: true,
          value: "id",
        },*/
        {
          text: "No. Expediente",
          align: "center",
          sortable: true,
          value: "no_Expediente",
        },
        {
          text: "Nombre del proyecto",
          align: "center",
          sortable: false,
          value: "nombre_Proyecto",
        },
        {
          text: "Categoria",
          align: "center",
          sortable: false,
          value: "categoria",
        },
        {
          text: "Tipo Instrumento",
          align: "center",
          sortable: false,
          value: "tipo_Instrumento",
        },
        {
          text: "Estado",
          align: "center",
          sortable: false,
          value: "estadoExpediente",
          filter: this.filtroEstado,
        },
        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "",
        },
      ];
    },

    headersContactos() {
      return [
        {
          text: "Id",
          //align: "start",
          sortable: false,
          value: "id",
          align: " d-none",
        },
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Área",
          align: "start",
          sortable: true,
          value: "area",
        },
        {
          text: "Cargo",
          align: "start",
          sortable: true,
          value: "cargo",
        },
        {
          text: "Dirección",
          align: "start",
          sortable: true,
          value: "direccion",
        },
        {
          text: "Correo(s)",
          align: "start",
          sortable: true,
          value: "correo",
        },
        {
          text: "Teléfono(s)",
          align: "start",
          sortable: true,
          value: "telefono",
        },
        {
          text: "Acciones",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
    headersRepoDocs() {
      return [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Documento",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
    fechaIniciaVistaPublica: {
      get: function () {
        return this.fechas.fechaIniciaVP
          ? moment(this.fechas.fechaIniciaVP).format("DD-MM-YYYY")
          : null;
      },
      set: function (val) {
        this.datosEdictoItem.iniciaVP = moment(val, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        //console.log(this.datosEmpresa.fecha_Nacimiento )
        return val;
      },
    },
    fechaFinalizaVistaPublica: {
      get: function () {
        return this.fechas.fechaFinalizaVP
          ? moment(this.fechas.fechaFinalizaVP).format("DD-MM-YYYY")
          : null;
      },
      set: function (val) {
        this.datosEdictoItem.finalizaVP = moment(val, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        //console.log(this.datosEmpresa.fecha_Nacimiento )
        return val;
      },
    },
    fechaPublicacion: {
      get: function () {
        return this.fechas.fechaPublicacion
          ? moment(this.fechas.fechaPublicacion).format("DD-MM-YYYY")
          : null;
      },
      set: function (val) {
        this.datosEdictoItem.fechaPublicacion = moment(
          val,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        //console.log(this.datosEmpresa.fecha_Nacimiento )
        return val;
      },
    },
  },
  watch: {
    //Cambiar el formato de fecha de nacimiento del objeto datosEmpresa al momento de que fechas.fechaNacimiento cambie
    "fechas.fechaIniciaVP": function (val) {
      this.datosEdictoItem.iniciaVP = val;
    },
    "fechas.fechaFinalizaVP": function (val) {
      this.datosEdictoItem.finalizaVP = val;
    },
    "fechas.fechaPublicacion": function (val) {
      this.datosEdictoItem.fechaPublicacion = val;
    },

    menuFechaInicialVistaPublica(val) {
      val && setTimeout(() => (this.activePickerIniciaVP = "YEAR"));
    },
    menuFechaFinalizaVistaPublica(val) {
      val && setTimeout(() => (this.activePickerFinalizaVP = "YEAR"));
    },
    menuFechaPublicacion(val) {
      val && setTimeout(() => (this.activePickerPublicacion = "YEAR"));
    },
  },
};
</script>
<style>
.v-data-table .td {
  vertical-align: middle;
}
</style>
